import getScrollBarSize from '@lib/utils/getScrollBarSize';
import { createGlobalStyle } from 'styled-components';
import { pickerCommonStyles } from '../../components/ui/pickers/common.styled';
import { TooltipCss } from '../../components/ui/tooltip/tooltip.styled';

const GlobalStyle = createGlobalStyle`
  ${pickerCommonStyles};
  ${TooltipCss};

  body{
     color: ${({ theme }) => theme.color.tint.onPrimary};
     font-size: ${({ theme }) => theme.typography.htmlFontSize}px;
     font-family: ${({ theme }) => theme.typography.fontFamily};
     font-weight: ${({ theme }) => theme.typography.fontWeight};
     -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  body, #root{
    min-height:100vh;
  }

  body.auth-menu-open {
    overflow: hidden;
  }
  body.auth-menu-open-overflown {
    overflow: hidden;
    padding-right: ${getScrollBarSize(true)}px;
  }

  .DayPicker-WeekdaysRow {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .DayPicker-Weekdays {
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .DayPicker-Weekday {
    display: block;
    padding: 0px;
    font-weight: 600;
    width: 20px;
    color: #181e34;
    opacity: 0.2;
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    text-transform: capitalize;
    text-align: center;
    abbr {
      cursor: initial !important;
    }
  }

  .DayPicker-wrapper {
    width: 100%;
    outline: none;
  }

  .DayPicker-Month {
    margin: 0 0;
    width: 100%;
    display: block;
  }

  .DayPicker-Body {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .DayPicker-Week {
    outline: none;
    width: 100%;
    justify-content: space-between;
    display: flex;
    margin: 12px 0;
  }

  .DayPicker-Day {
    outline: none;
    font-family: 'Mulish', sans-serif;
    display: block;
    padding: 0;
    border-radius: 50%;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #333d6c;
    cursor: pointer;
    width: 20px;
    z-index: 0;
    &:hover {
      position: relative;
      z-index: 0;
      background: none !important;
      &:before {
        content: '';
        z-index: -1;
        width: 30px;
        height: 30px;
        position: absolute;
        left: -5px;
        top: -2px;
        border-radius: 50%;
        background: rgba(51, 61, 108, 0.1);
      }
    }

    &--outside {
      width: 20px;
      display: block;
      padding: 0;
      opacity: 0;
      cursor: initial;
      &:hover {
        opacity: 0;
      }
    }

    &--weekends {
      color: rgba(51, 61, 108, 0.2);
    }

    &--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      position: relative;
      z-index: 99;
      color: #6ae59f;
      background: none;
      &:before {
        content: '';
        z-index: -1;
        width: 30px;
        height: 30px;
        position: absolute;
        left: -5px;
        top: -2px;
        border-radius: 50%;
        background-color: rgba(106, 229, 159, 0.2);
      }
      &.DayPicker-Day--highlighted {
        color: white !important;
        &:before {
          background-color: #5dcf8e !important;
        }
      }
    }

    &--highlighted:not(.DayPicker-Day--outside) {
      position: relative;
      z-index: 0;
      color: white;
      background: none;
      &:before {
        content: '';
        z-index: -1;
        width: 30px;
        height: 30px;
        position: absolute;
        left: -5px;
        top: -2px;
        border-radius: 50%;
        background-color: #6ae59f;
      }
      &:hover {
        color: white !important;
        background: none;
        &:before {
          content: '';
          z-index: -1;
          width: 30px;
          height: 30px;
          position: absolute;
          left: -5px;
          top: -2px;
          border-radius: 50%;
          background-color: #5dcf8e !important;
        }
      }
    }

    &--today {
      font-size: 16px;
      color: #333d6c;
      font-weight: 600;
      position: relative;
      background: none;
      z-index: 0;
      &:before {
        content: '';
        z-index: -1;
        width: 30px;
        height: 30px;
        position: absolute;
        left: -5px;
        top: -2px;
        border-radius: 50%;
        background: rgba(51, 61, 108, 0.2);
      }
      &.DayPicker-Day--outside {
        opacity: 0;
      }
    }
  }
`;

export default GlobalStyle;
